import { NgModule } from "@angular/core";

import { HfestFamiliesDb } from "./hfest-families-db.mjs";
import { HfestItemNamePipe } from "./hfest-item-name.pipe.mjs";
import { HfestItemsDbService } from "./hfest-items-db.service.mjs";

@NgModule({
  declarations: [
    HfestItemNamePipe,
  ],
  exports: [
    HfestItemNamePipe,
  ],
  providers: [
    HfestFamiliesDb,
    HfestItemsDbService,
  ],
})
export class HfestDbModule {
}
